import { isUsEquityRegularSessionOpen } from "../shared/marketHours";

export interface MarketSessionStatus {
  open: boolean;
  label: string;
  detail: string;
}

export function marketSessionStatus(now = new Date()): MarketSessionStatus {
  const open = isUsEquityRegularSessionOpen(now);
  return {
    open,
    label: open ? "Open" : "Closed",
    detail: "Regular market hours, 9:30–16:00 ET",
  };
}

function escAttr(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

export function marketStatusIndicatorHtml(now = new Date()): string {
  const status = marketSessionStatus(now);
  return `<span class="sfe-market-status sfe-header-indicator ${status.open ? "open" : "closed"}" title="${escAttr(status.detail)}" aria-label="Market ${status.label.toLowerCase()}"><span class="sfe-header-indicator-dot" aria-hidden="true"></span><span class="sfe-header-indicator-label">${status.label}</span></span>`;
}

export function applyMarketStatusIndicator(host: HTMLElement, now = new Date()): void {
  const el = host.querySelector<HTMLElement>(".sfe-market-status");
  if (!el) return;
  const status = marketSessionStatus(now);
  el.classList.toggle("open", status.open);
  el.classList.toggle("closed", !status.open);
  el.title = status.detail;
  el.setAttribute("aria-label", `Market ${status.label.toLowerCase()}`);
  const label = el.querySelector<HTMLElement>(".sfe-header-indicator-label");
  if (label) label.textContent = status.label;
}

const MARKET_STATUS_POLL_MS = 60_000;

export function startMarketStatusPolling(
  host: HTMLElement,
  onTick?: (status: MarketSessionStatus) => void,
): () => void {
  const tick = (): void => {
    const status = marketSessionStatus();
    applyMarketStatusIndicator(host);
    onTick?.(status);
  };
  tick();
  const id = window.setInterval(tick, MARKET_STATUS_POLL_MS);
  return () => window.clearInterval(id);
}
